var _defs, _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdamantineRockActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 20.2,
    y1: 66.9,
    x2: 37,
    y2: 66.9,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 34.3,
    y1: 80.3,
    x2: 38.5,
    y2: 80.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g3",
    x1: 37.9,
    y1: 74.2,
    x2: 46,
    y2: 74.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g4",
    x1: 37.9,
    y1: 81,
    x2: 56.3,
    y2: 81,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g5",
    x1: 58.3,
    y1: 84,
    x2: 66.9,
    y2: 84,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g6",
    x1: 51.9,
    y1: 92.3,
    x2: 63.5,
    y2: 92.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g7",
    x1: 52,
    y1: 75.4,
    x2: 58.6,
    y2: 75.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g8",
    x1: 54.3,
    y1: 101.1,
    x2: 72.5,
    y2: 101.1,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g9",
    x1: 68,
    y1: 96.5,
    x2: 73.7,
    y2: 96.5,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g10",
    x1: 72.3,
    y1: 84.8,
    x2: 89.2,
    y2: 84.8,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g11",
    x1: 86.4,
    y1: 80.4,
    x2: 94.1,
    y2: 80.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g12",
    x1: 90.6,
    y1: 73,
    x2: 96.4,
    y2: 73,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g13",
    x1: 66.8,
    y1: 77.4,
    x2: 78.2,
    y2: 77.4,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g14",
    x1: 10.2,
    y1: 9.2,
    x2: 117.7,
    y2: 9.2,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a36324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9a726"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#1f0a34}.b{fill:url(#g1)}.c{fill:url(#g2)}.d{fill:url(#g3)}.e{fill:url(#g4)}.f{fill:url(#g5)}.g{fill:url(#g6)}.h{fill:url(#g7)}.i{fill:url(#g8)}.j{fill:url(#g9)}.k{fill:url(#g10)}.l{fill:url(#g11)}.m{fill:url(#g12)}.n{fill:url(#g13)}.o{fill:url(#g14)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m127.5 64.2c0 35.1-28.5 63.6-63.6 63.6-35.1 0-63.5-28.5-63.5-63.6 0-35.1 28.4-63.5 63.5-63.5 35.1 0 63.6 28.4 63.6 63.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m37 75.4l-8.4 8.4-8.4-8.4 8.4-8.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "m38.5 82.3l-2.1 2.1-2.1-2.1 2.1-2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "m46 78.3l-4.1 4-4-4 4-4.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "m56.3 90.2l-9.2 9.1-9.2-9.1 9.2-9.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "m66.9 88.3l-4.3 4.3-4.3-4.3 4.3-4.3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "m63.5 97.9l-6 6-5.6-5.6 6-6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "m58.6 78.6l-3.4 3.4-3.2-3.2 3.4-3.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "m72.5 109.9l-9.4 9.4-8.8-8.8 9.4-9.4z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "m73.7 99.3l-2.9 2.9-2.8-2.8 3-2.9z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "m89.2 93l-8.7 8.7-8.2-8.2 8.7-8.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "m94.1 84.2l-4 3.9-3.7-3.7 4-4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "m96.4 75.8l-3 3-2.8-2.8 3-3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "m78.2 83l-5.9 5.9-5.5-5.6 5.9-5.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "o",
    d: "m117.7 62.6l-9.9 10-2.6-2.6-6.4 6.4-6.4-6.4-2.1 2-5.4-5.4-1.4 1.3 6.8 6.8-8.7 8.8-8.1-8.1 7.1-7.1-1.5-1.5-6.5 6.4-1.1-1.1-7.2 7.3-8.5-8.4-1.3 1.3-1.8-1.8-5.7 5.7-7.1-7.1-2.9 2.8-8.6-8.6-8.8 8.8-9.4-9.5 53.4-53.4zm-8-0.5l-34.6-33.7-4.2-4.2-2.8-2.7-4.2-4.1-4.3 4.1-2.7 2.7-4.2 4.2-34.6 33.7h8.4l30.4-29.6 4.2-4.1 2.8-2.8 2.7 2.8 4.3 4.1 25.5 24.9h-5.6l-22.7-22.2-4.2-4.1-4.3 4.1-27.6 26.9h50.4l-4.8-4.7-9.6-9.4-4.1-4-4.2 4-7 6.9h8.3l2.9-2.8 5.4 5.3h-24l18.6-18.1 23.3 22.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdamantineRockActive);
export default __webpack_public_path__ + "static/media/adamantine-rock-active.e3739e8db0ac5bdf858880f0a80342db.svg";
export { ForwardRef as ReactComponent };